import React, { Component } from "react";
import "./style.scss";
import classNames from "classnames";
import { generateReactKey } from "../../utils/reactKey";

export default class Table extends Component {
  constructor(props, context) {
    super(props, context);
    const { fields } = this.props;
    const { sortIsEnabled, rows } = fields;

    if (sortIsEnabled.value) {
      let sortOrder = [];

      //asc|desc|none
      fields.headings.forEach(column => {
        sortOrder.push("none");
      });
      this.state = {
        sortOrder: sortOrder,
        rows: rows
      };
    } else {
      this.state = {
        rows: rows
      };
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      width: this.refs.scrollContainer ? this.refs.scrollContainer.clientWidth : "auto",
      scrollWidth: this.refs.scrollContainer ? this.refs.scrollContainer.scrollWidth : "auto"
    });
  }

  addIsTableFilterScrolled() {
    if (!this.state.isTableFilterScrolled) {
      this.setState({
        isTableFilterScrolled: true
      });
      window.addEventListener("scroll", this.removeIsTableFilterScrolled.bind(this));
      window.addEventListener("click", this.removeIsTableFilterScrolled.bind(this));
      this.refs.scrollContainer.removeEventListener("scroll", this.addIsTableFilterScrolled.bind(this));
    }
  }

  removeIsTableFilterScrolled() {
    if (this.state.isTableFilterScrolled) {
      this.setState({
        isTableFilterScrolled: false
      });
      this.refs.scrollContainer.addEventListener("scroll", this.addIsTableFilterScrolled.bind(this));
      window.removeEventListener("scroll", this.removeIsTableFilterScrolled.bind(this));
      window.removeEventListener("click", this.removeIsTableFilterScrolled.bind(this));
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    this.refs.scrollContainer.addEventListener("scroll", this.addIsTableFilterScrolled.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions.bind(this));
    window.removeEventListener("scroll", this.removeIsTableFilterScrolled.bind(this));
    window.removeEventListener("click", this.removeIsTableFilterScrolled.bind(this));
    this.refs.scrollContainer.removeEventListener("scroll", this.addIsTableFilterScrolled.bind(this));
  }

  sortOnColumn = (index, event) => {
    event.preventDefault();

    if (this.props.fields.sortIsEnabled.value === false) {
      return;
    }

    let sortOrder = this.state.sortOrder;
    let newOrder;

    if (sortOrder[index] === "none" || sortOrder[index] === "desc") {
      newOrder = "asc";
    } else {
      newOrder = "desc";
    }

    //rest all other columns

    sortOrder = sortOrder.map(x => "none");
    sortOrder[index] = newOrder;

    // sort rows.
    let rowsCopy = this.state.rows;
    rowsCopy.sort((a, b) => {
      return a.fields.items[index].fields.text.value.localeCompare(b.fields.items[index].fields.text.value);
    });
    if (newOrder === "desc") {
      rowsCopy = rowsCopy.reverse();
    }

    this.setState({ rows: rowsCopy, sortOrder: sortOrder });
  };

  hasScroll() {
    let elem = this.refs.scrollContainer;

    if (elem) {
      return elem.scrollWidth > elem.clientWidth;
    }
    return true;
  }

  head(item, index, model, columnWidthStyle) {
    const sortClasses = classNames({
      asc: this.state.sortOrder && this.state.sortOrder[index] === "asc",
      desc: this.state.sortOrder && this.state.sortOrder[index] === "desc"
    });
    return (
      <th
        key={`th-${index}`}
        onClick={evt => this.sortOnColumn(index, evt)}
        align="left"
        className={classNames({
          sort: model.sortIsEnabled.value,
          "lead-column": index === 0
        })}
        style={{
          background: index === 0 && model.backgroundColor?.fields.phrase.value ? model.backgroundColor.fields.phrase.value : undefined,
          ...columnWidthStyle
        }}
      >
        <span>{item}</span>
        {model.sortIsEnabled.value && (
          <span className={sortClasses}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M8 5v14l11-7L8 5z" />
            </svg>
          </span>
        )}
      </th>
    );
  }

  row(row, index, model) {
    return (
      <tr key={`tr-${index}`}>
        {row.items &&
          row.items.map((subitem, subindex) => {
            let cellBackground = subindex === 0 && model.backgroundColor?.fields.phrase.value ? model.backgroundColor.fields.phrase.value : undefined;

            let tdClasses = classNames({
              "lead-column": model.firstColumnIsLeadColumn.value && subindex === 0,
              highlight: model.highlightRowDifferences && subindex === row.items.length - 1 && row.items[subindex - 1].fields.text.value !== subitem.fields.text.value
            });
            return (
              <td
                key={subindex}
                className={tdClasses}
                style={{
                  background: cellBackground
                }}
              >
                {row.link.value.href && (
                  <div>
                    <a href={row.link.value.href}>{subitem.fields.text.value}</a>
                  </div>
                )}
                {!row.link.value.href && subitem.fields.text.value}
              </td>
            );
          })}
      </tr>
    );
  }

  render() {
    const { fields } = this.props;
    const { headings, firstColumnIsHeadColumn, columnsAreEqual, backgroundColor, noRowsBody } = fields;

    const showFilterClass = !this.state.isTableFilterScrolled && this.hasScroll() && this.state.scrollWidth > this.state.width && !columnsAreEqual?.value ? "table-filter" : "";

    let columnWidthStyle = {};
    if (columnsAreEqual?.value) {
      let numbrOfColumns = headings.length;
      columnWidthStyle = { width: `${100 / numbrOfColumns}%` };
    }

    return (
      <div key={generateReactKey()} className={"table-wrapper"}>
        <div
          ref={"scrollFilterContainer"}
          className={showFilterClass}
          style={{
            background: backgroundColor?.fields.phrase.value ? `linear-gradient(to right, transparent, ${backgroundColor.fields.phrase.value} 100%)` : undefined
          }}
        />
        <div
          className={classNames({
            "scroll-container": !columnsAreEqual?.value,
            equal: columnsAreEqual?.value
          })}
          ref="scrollContainer"
        >
          <table className={`table ${firstColumnIsHeadColumn?.value ? "first-column-head" : ""}`}>
            <thead>
              {firstColumnIsHeadColumn?.value && headings?.length && (
                <tr className="head-row">
                  <th colSpan={headings?.length}>
                    <span>{headings[0].fields.text.value}</span>
                  </th>
                </tr>
              )}
              <tr>{headings.map((item, index) => this.head(item.fields.text.value, index, fields, columnWidthStyle))}</tr>
            </thead>
            <tbody>
              {this.state.rows &&
                this.state.rows.map((row, index) => {
                  return (
                    <>
                      {firstColumnIsHeadColumn?.value && (
                        <tr className="head-row">
                          <td colSpan={row.fields.items.length}>{row.fields.items[0].fields.text.value}</td>
                        </tr>
                      )}
                      {this.row(row.fields, index, fields)}
                    </>
                  );
                })}
            </tbody>
          </table>
          {noRowsBody && !this.state.rows?.length && (
            <div
              className={"body"}
              dangerouslySetInnerHTML={{
                __html: noRowsBody
              }}
            />
          )}
        </div>
      </div>
    );
  }
}
